import { LoadingOutlined } from "@ant-design/icons";
import { Col, Spin, Table, Typography } from "antd";
import { Paging } from "api/baseApiResponseModel/BaseApiResponseModel";
import { useState } from "react";
import { colorFormat } from "utils/format/ColorFormat";
import { TableComponentModel } from "./model/TableComponentModel";

const { Text } = Typography;

const TableComponent = <T extends Object>(props: TableComponentModel<T>) => {
  const { data } = props;

  const [detailPage, setDetailPage] = useState<number>(0);
  const [detailPageSize, setDetailPageSize] = useState<number>(10);

  const handleDetailTableChange = async (pagination?: Paging | any) => {
    setDetailPage(pagination?.current! - 1);
    setDetailPageSize(pagination?.pageSize);
  };

  const handleTotal = (total: number): JSX.Element => (
    <Text className="left-0 absolute font-medium">
      {data?.totalTitle}:
      <Text style={{ color: colorFormat?.Blue }} className="text-base ml-2">
        {total}
      </Text>{" "}
    </Text>
  );
  return (
    <Col span={24} className="mt-1">
      {data?.forDetail === true ? (
        <Table
          columns={[
            {
              title: "STT",
              width: "5%",
              render: (item, record, index) => (
                <span className="font-semibold">
                  {data?.page * data?.pageSize + index + 1}
                </span>
              ),
              align: "center",
            },
            ...data?.columns,
          ]}
          size="middle"
          showSorterTooltip={false}
          dataSource={data?.dataSource}
          onChange={handleDetailTableChange}
          scroll={data?.scroll}
          rowKey={!!data?.rowKey ? data?.rowKey : null}
          className="h-full"
          pagination={{
            pageSize: detailPageSize,
            current: detailPage + 1,
            total: data?.dataSource?.length,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            showTotal: handleTotal,
          }}
        />
      ) : (
        <Spin
          spinning={data?.loading}
          indicator={
            <LoadingOutlined className="text-blue-600 font-semibold" />
          }
          tip={
            <span className="font-semibold text-blue-600">
              {data?.loadingTitle}
            </span>
          }
        >
          <Table
            columns={[
              {
                title: "STT",
                width: "50px",
                render: (item, record, index) => (
                  <span className="font-semibold">
                    {data?.page * data?.pageSize + index + 1}
                  </span>
                ),
                align: "center",
              },
              ...data?.columns,
            ]}
            rowKey={data?.rowKey}
            size="middle"
            showSorterTooltip={false}
            dataSource={data?.dataSource}
            onChange={data?.handleTableChange}
            scroll={data?.scroll}
            className="h-full"
            pagination={{
              pageSize: data?.pageSize,
              current: data?.page + 1,
              total: data?.total,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: handleTotal,
            }}
          />
        </Spin>
      )}
    </Col>
  );
};

export default TableComponent;
